export const STRIPE_PAYMENT_METHODS = {
  CARD: 'card',
  SEPA: 'sepa',
  SOFORT: 'sofort',
  IDEAL: 'ideal',
};

export const MINIMUM_NON_CREDIT_CARD_NAME_LENGTH = 3;

export const SEPA_BASED_PAYMENT_METHODS = Object.freeze([STRIPE_PAYMENT_METHODS.IDEAL, STRIPE_PAYMENT_METHODS.SOFORT]);

export const DEFAULT_PAYMENT_METHOD_ID = STRIPE_PAYMENT_METHODS.CARD;

export const SELECTOR_COMPONENT_TYPE = {
  dropdown: 'PaymentMethodSelectorDropdown',
  tabs: 'PaymentMethodSelectorTabs',
};
